/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var ArrowIcon = createIcon({
  name: 'ArrowIcon',
  height: 1024,
  width: 1097,
  svgPath: 'M921.6-73.143h-885.029c-21.943 0-36.571 14.629-36.571 36.571v804.571c0 21.943 14.629 36.571 36.571 36.571h292.571l-109.714-146.286h-73.143v-585.143h658.286v73.143l146.286 146.286v-329.143c0-21.943-14.629-36.571-29.257-36.571v0zM665.6 731.428c-219.429 0-394.971-131.657-373.029-351.086 14.629-138.971 87.771-160.914 146.286-204.8-58.514 124.343 36.571 321.829 263.314 336.457 7.314 0 21.943 0 29.257 0v-219.429l365.714 329.143-365.714 329.143v-219.429c0 0-65.829 0-65.829 0z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
});
export default ArrowIcon;